export const cibDelicious = ["32 32","<path d='M16 16h-16v16h16zM32 0h-16v16h16z'></path>"]